import { type Html } from 'rune-ts';
import { ProductBadgeBase } from '../ProductBadgeBase';
import { ProductBadgeStyleHelper } from '../ProductBadgeStyleHelper';
import klass from '../styles/ProductBadge.module.scss';

export class PopularBadge extends ProductBadgeBase<undefined> {
  protected setLabel(): void {
    this.label = ET('mps2::product::badge::popular', {
      lng: this.data.option.lang,
    });
  }

  protected isTimerNeeded(): boolean {
    return false;
  }

  protected getIcon(): Html | string | null {
    return null;
  }

  protected getStyles(): string {
    return klass.popular;
  }

  protected getTypo(): string {
    return ProductBadgeStyleHelper.getBaseTypo(this.data.option.size);
  }
}
